import React, { useEffect, useState } from "react";
import axios from "axios";
import { Star, ExternalLink } from "lucide-react";
import { SITE, LIVE_STATS } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIGURES = [
  { value: `${LIVE_STATS.scanned}+`, label: "Biens scannés" },
  { value: `${LIVE_STATS.clients}+`, label: "Clients accompagnés" },
  { value: `${LIVE_STATS.cities}`, label: "Communes visitées" },
  { value: "48h", label: "Livraison ouvrées" },
];

// Rassurance immédiate : note Google réelle + chiffres clés, juste sous le hero.
export default function TrustBar() {
  const [google, setGoogle] = useState(null);

  useEffect(() => {
    axios.get(`${API}/google-reviews`).then((r) => setGoogle(r.data)).catch(() => setGoogle(null));
  }, []);

  const live = google && google.rating != null;
  const rating = live ? google.rating.toFixed(1).replace(".", ",") : "5,0";

  return (
    <section className="section-alt border-y border-white/5" data-testid="trust-bar">
      <div className="vp-shell px-6 md:px-10 py-7 md:py-9">
        <div
          className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10 vp-fade-rise"
        >
          <div className="flex items-center gap-4 lg:border-r lg:border-white/10 lg:pr-10">
            <div className="flex flex-col">
              <div className="flex items-center gap-2">
                <span className="font-display text-3xl font-semibold text-white" data-testid="trust-rating">
                  {rating}
                </span>
                <span className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-[#FBBC05] text-[#FBBC05]" />
                  ))}
                </span>
              </div>
              <a
                href={live && google.maps_uri ? google.maps_uri : SITE.googleBusinessUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="trust-reviews-link"
                className="mt-1 inline-flex items-center gap-1.5 min-h-[40px] lg:min-h-0 text-xs text-zinc-400 hover:text-[#FF4D6D] transition-colors"
              >
                {live && google.total != null ? `${google.total} avis Google vérifiés` : "Avis Google vérifiés"}
                <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          </div>

          <dl className="grid grid-cols-2 sm:grid-cols-4 gap-5 md:gap-8 flex-grow">
            {FIGURES.map((f) => (
              <div key={f.label} data-testid={`trust-figure-${f.label}`}>
                <dt className="font-display text-xl md:text-2xl font-semibold text-white tabular-nums">{f.value}</dt>
                <dd className="text-[11px] uppercase tracking-[0.16em] text-zinc-500 mt-1">{f.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
